module.exports = __webpack_public_path__ + "img/my_kyc_ex2.ba7c7cbd.webp";